import AddIcon from '@eduzz/houston-icons/Add';
import Select from '@eduzz/houston-ui/Forms/Select';
import Table from '@eduzz/houston-ui/Table';
import { Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import ModalActions from 'components/ModalActions';
import PermissionHide from 'components/PermissionHide';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { listMyConnects, loadConnect, changeStatusConnect } from 'store/Orbita/Connect/actions';
import TopPage from 'v2/components/Shared/TopPage';
import Truncate from 'v2/components/Shared/TruncateText';
import WithBetaModules from 'v2/components/Shared/WithBetaModules';

import NewConnect from '../components/NewConnect';
import styles from '../styles/';

import type { DispatchProp } from 'react-redux';
import type { RouteComponentProps } from 'react-router-dom';

const RDSTATION = 18,
  RDSTATIONEW = 44,
  GDIGITAL = 43,
  GDIGITALNEW = 46;

interface IProps extends DispatchProp<any>, RouteComponentProps<any> {
  connects: any;
  modal?: boolean;
  classes: any;
  pagination: any;
  currentConnect: any;
  connect: any;
  autoresponders: any;
}

interface IStates {
  isFetching: boolean;
  openForm: boolean;
  editing: boolean;
  openModalDisable: boolean;
  filter: any;
}
class Connect extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isFetching: false,
      openForm: false,
      editing: false,
      openModalDisable: false,
      filter: null,
    };
    this.openModal = this.openModal.bind(this);
  }

  componentDidMount() {
    this.callDataInitial();
  }

  handlePressEnter = (e: any) => {
    if (e.key === 'Enter') {
      this.callDataInitial();
    }
  };

  handleCloseForm = () => {
    this.setState({ openForm: false, editing: false });
  };

  handleEditConnect = () => {
    this.setState({});
    (async () => {
      await this.props.dispatch(loadConnect(this.props.currentConnect.id));
      let { connect } = this.props;
      await this.props.dispatch({ type: 'CHANGE_CURRENT_CONNECT', connect });
      this.props.dispatch({ type: 'OPEN_MODAL_EDIT_CONNECT' });
    })();
  };

  handleMenuOpen = (event: any, connect: any) => {
    this.props.dispatch({ type: 'CHANGE_CURRENT_CONNECT', connect });
  };

  callDataInitial = () => {
    this.callMoreData({
      per_page: 25,
      current_page: 1,
    });
  };

  openModalDisableConnect = (connect: any) => {
    this.setState({ openModalDisable: true });
    this.props.dispatch({ type: 'CHANGE_CURRENT_CONNECT', connect });
  };

  onCancelModal = () => {
    this.setState({ openModalDisable: false });
  };

  changeConnectStatus = (status: boolean) => {
    (async () => {
      try {
        await this.props.dispatch(changeStatusConnect(this.props.currentConnect.id, status));
        this.setState({ openModalDisable: false });
        toast.success(`Connect ${status ? 'ativado' : 'desativado'} com sucesso!`);
        this.callDataInitial();
      } catch (error) {
        toast.error(error);
      }
    })();
  };

  onChangeRowsPerPage = (per_page: number) => {
    this.callMoreData({ ...this.props.pagination, per_page, current_page: 1 });
  };

  onChangePage = (page: number) => {
    this.callMoreData({ ...this.props.pagination, current_page: page });
  };

  callMoreData = async (pagination: any) => {
    this.setState({ isFetching: true, openForm: false, editing: false });
    await this.props.dispatch(listMyConnects(pagination));
    this.setState({ isFetching: false });
  };

  openModal = () => {
    this.props.dispatch({ type: 'OPEN_MODAL_NEW_CONNECT' });
  };

  onSave = () => {
    this.callDataInitial();
  };

  render() {
    const { pagination, currentConnect, classes, autoresponders, connects } = this.props;
    const filter = this.state.filter;
    const isLoading = this.state.isFetching;
    const providers = Array.isArray(autoresponders) ? autoresponders : [];

    const listConnects = Array.isArray(connects) ? connects : [];
    const filteredConnects = listConnects.filter((c) => {
      if (!filter || filter == '') return true;
      if (filter === RDSTATION && (c.autoresponder_id === RDSTATION || c.autoresponder_id === RDSTATIONEW)) return true;
      if (filter === GDIGITAL && (c.autoresponder_id === GDIGITAL || c.autoresponder_id === GDIGITALNEW)) return true;
      if (c.autoresponder_id === filter) return true;
      return false;
    });

    return (
      <>
        <TopPage
          title='Connect'
          action={
            <PermissionHide action={'myeduzz:connect:criar'}>
              <Button startIcon={<AddIcon />} variant='contained' color='primary' onClick={this.openModal}>
                Nova integração
              </Button>
            </PermissionHide>
          }
        />

        <PermissionHide action='owner'>
          <WithBetaModules>
            {(betaModules: string[]) => {
              if (betaModules?.includes('new_connect')) {
                return (
                  <Alert severity='info'>
                    <strong>Uma nova forma de fazer integrações está chegando! </strong>
                    <span>
                      Estamos criando uma nova versão do Connect Eduzz e já migramos alguns dos seus provedores para a nova versão.{' '}
                      <Link to='/producer/new-connect'>Bora conferir?</Link>
                    </span>
                  </Alert>
                );
              }

              return null;
            }}
          </WithBetaModules>
        </PermissionHide>

        <Grid container spacing={2} justifyContent='flex-end'>
          <Grid item xs={12} md={3}>
            <Select label='Plataforma' value={filter} onChange={(v) => this.setState({ filter: v })}>
              <Select.Option>Todas</Select.Option>
              {providers
                .filter((a) => a.id !== RDSTATIONEW && a.id !== GDIGITALNEW)
                .map((option: any) => (
                  <Select.Option value={option.id} key={option.id}>
                    {option.name}
                  </Select.Option>
                ))}
            </Select>
          </Grid>
          <Grid item xs={12}>
            <Table loading={isLoading} total={pagination?.total_items} emptyText='Nenhuma integração encontrada'>
              <Table.Header>
                <Table.Column>Status</Table.Column>
                <Table.Column>Plataforma</Table.Column>
                <Table.Column>Descrição</Table.Column>
                <Table.Column>Dados de configuração</Table.Column>
              </Table.Header>
              <Table.Body>
                {filteredConnects.map((connect: any, index: number) => (
                  <Table.Row data={connect} index={index} key={`connect-${connect.id}`}>
                    <Table.Cell>
                      <div>{connect.active ? <div style={{ color: '#009358' }}>Ativo</div> : <div style={{ color: '#dc3f53' }}>Inativo</div>}</div>
                    </Table.Cell>
                    <Table.Cell align='left' className={classes.connectCell}>
                      <div
                        className={classes.imageTable}
                        style={{ backgroundImage: `url(${connect.image})` }}
                        title={connect.name || 'Desconhecido'}
                      ></div>
                    </Table.Cell>
                    <Table.Cell>{connect.description}</Table.Cell>
                    <Table.Cell>
                      <b>{connect?.parameters[0]?.label ?? '-'}</b>
                      <Truncate count={100} final='...'>
                        {connect?.parameters[0]?.value}
                      </Truncate>
                    </Table.Cell>
                    {connect?.migrated ? (
                      <Table.Action onClick={() => this.props.history.push('/producer/new-connect')}>Editar no Novo Connect</Table.Action>
                    ) : (
                      <>
                        <Table.Action onClick={() => this.openModalDisableConnect(connect)}>{connect?.active ? 'Desativar' : 'Ativar'}</Table.Action>
                        <Table.Action onClick={() => this.props.history.push(`/producer/connect/${connect.id}/actions`)}>Ver Ações</Table.Action>
                      </>
                    )}
                  </Table.Row>
                ))}
              </Table.Body>

              {!isLoading && pagination && (
                <Table.Pagination
                  page={pagination?.current_page ?? 1}
                  perPage={pagination?.per_page ?? 25}
                  onChangePage={this.onChangePage}
                  onChangePerPage={this.onChangeRowsPerPage}
                  optionsPerPage='10,25,50'
                />
              )}
            </Table>
          </Grid>

          <NewConnect onSave={this.onSave} handleClose={null} />
          <ModalActions
            open={this.state.openModalDisable}
            onClose={this.onCancelModal}
            onOk={() => this.changeConnectStatus(!currentConnect.active)}
            title={'Atenção'}
            buttonOk={'Confirmar'}
            loadingColor='#ccc'
          >
            <p>
              Você deseja realmente {currentConnect && currentConnect.active ? 'desativar' : 'ativar'} o connect{' '}
              <b>{currentConnect && currentConnect.name}</b> - {currentConnect?.description} ?{' '}
            </p>
          </ModalActions>
        </Grid>
      </>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    connects: state.orbita.Connect.listMyConnects.data,
    pagination: state.orbita.Connect.listMyConnects.pagination,
    currentConnect: state.components.Connect.currentConnect,
    connect: state.orbita.Connect.loadConnect,
    autoresponders: state.orbita.Connect.listConnect,
  };
}

export default withRouter(connect(mapStateToProps)(styles(Connect)));
